import { render } from "./uiDescriptionList.vue?vue&type=template&id=566fde48"
import script from "./uiDescriptionList.vue?vue&type=script&lang=js"
export * from "./uiDescriptionList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__